import { Navigate } from 'react-router-dom';
import { Routes } from '@/routes';
import DormitoryRegisterSolitaryManagement from './DormitoryRegisterSolitaryManagement';

export interface DormitoryRegisterSolitaryProps {
  group: DormitoryGroup;
  validEntrance: DormitoryValidEntranceResponse;
  onRefresh: () => void;
}

export default function DormitoryRegisterSolitary({
  group,
  validEntrance,
  onRefresh
}: DormitoryRegisterSolitaryProps) {

  if (!group) {
    return <Navigate to={Routes.DormitorySolitrayRoomSelector} />;
  }

  return (
    <DormitoryRegisterSolitaryManagement
      group={group}
      onRefresh={onRefresh}
      validEntrance={validEntrance}
    />
  );
}
